import script from "./goRinSyo0029.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0029.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0029.vue?vue&type=style&index=0&id=7e9102d5&lang=scss"

const __exports__ = script;

export default __exports__